export default {
  title: 'Overlapping offer in the same time period',
  buttons: {
    save_as_active: 'Set as new active offer',
    save_as_inactive: 'Save as Inactive',
    cancel: 'Cancel',
  },
  description: {
    base: '{{offer}} overlaps with the active offer {{overlappingOffer}} on {{weekday}}{{between}}. You can only run one offer in the same time period.',
    between: ', between {{start}}-{{end}}',
  },
  how_to_resolve: {
    title: 'How to resolve: Choose one option below.',
  },
};
